import aboutThumb from "../../assets/images/all-img/about2/about-thumb.jpg";
import shape from "../../assets/images/all-img/about2/shape.png";

export default function AboutSection() {
	return (
		<div className="fugu--about-section2">
			<div className="container">
				<div className="fugu--section-title">
					<div className="fugu--hero-content">
						<h1>About our company</h1>
						<p>
							An NFT is a digital asset that represents real-world objects like art, music, in-game items
							and videos. They are bought and sold online, frequently with cryptocurrency, and they are
							generally encoded with the same underlying software as many cryptos.
						</p>
					</div>
				</div>
				<div className="fugu--thumb-thumb2 wow fadeInUpX" data-wow-delay=".10s">
					<img src={aboutThumb} alt="" />
				</div>
			</div>
			<div className="fugu--shpae5">
				<img src={shape} alt="" />
			</div>
		</div>
	);
}
